module.exports = __webpack_public_path__ + "static/media/6.90a2dc26.jpg";